import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GetRuntimeServerResponse  {
    _originalTypeClassName = "zAppDevManager.BO.GetRuntimeServerResponse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GetRuntimeServerResponse.translate = translateService;
}
this.ProxyURL = null;
this.ControlURL = null;
this.GetRuntimeServerResponseKey = null;
this._key = this.GetRuntimeServerResponseKey = 0; 
}

static translate: TranslateService;
_key: any;
ProxyURL:any;
ControlURL:any;
private _GetRuntimeServerResponseKey:any;
get GetRuntimeServerResponseKey(): any {
    return this._GetRuntimeServerResponseKey;
  }
set GetRuntimeServerResponseKey(value: any) {
    this._GetRuntimeServerResponseKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GetRuntimeServerResponseKey == null || $this.GetRuntimeServerResponseKey == 0;
            }


}